"use client";

// src/toaster.tsx
import { AlertCircleIcon, AlertTriangleIcon, CheckCircle2Icon, InfoIcon } from "lucide-react";
import { Toaster as Sonner } from "sonner";
import { toast } from "sonner";
import { jsx } from "react/jsx-runtime";
var Toaster = (props) => {
  const { theme = "system", toastOptions, ...rest } = props;
  return /* @__PURE__ */ jsx(
    Sonner,
    {
      theme,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          ...toastOptions?.classNames
        },
        ...toastOptions
      },
      icons: {
        success: /* @__PURE__ */ jsx(CheckCircle2Icon, { className: "size-5 text-green-500" }),
        error: /* @__PURE__ */ jsx(AlertCircleIcon, { className: "size-5 text-red-500" }),
        warning: /* @__PURE__ */ jsx(AlertTriangleIcon, { className: "size-5 text-yellow-500" }),
        info: /* @__PURE__ */ jsx(InfoIcon, { className: "size-5 text-blue-500" })
      },
      ...rest
    }
  );
};

export {
  Toaster,
  toast
};
